// extracted by mini-css-extract-plugin
module.exports = {"grid":"idt-overviewwindowbody_grid__1dg_z"};